import classNames from "classnames";
import React, { useContext } from "react";
import { FormContext } from "../../App";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import Label from "../Label/Label";
import style from "./Input.module.css";

interface InputProps {
  label: string;
  name: string;
  type?: string;
  required?: boolean;
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, name, required, type }, ref) => {
    const { register, errors } = useContext(FormContext);
    return (
      <div className={style.inputContainer}>
        <Label text={label} required={required} />
        <input
          ref={ref}
          type={type}
          {...register(name, {
            required: required && "Required field",
          })}
          className={classNames(style.inputElement, {
            [style.error]: errors[name],
          })}
        ></input>
        <ErrorMessage name={name} />
      </div>
    );
  }
);
export default Input;
